/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_DescriptionInputs */

const fr_manual_description = /** @type {(inputs: Manual_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montez le widget via JavaScript :`)
};

const en_manual_description = /** @type {(inputs: Manual_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mount the widget via JavaScript:`)
};

/**
* | output |
* | --- |
* | "Mount the widget via JavaScript:" |
*
* @param {Manual_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_description = /** @type {((inputs?: Manual_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_description(inputs)
	return en_manual_description(inputs)
});